const AppName = (applicationStatus) => {
    if (applicationStatus === 'development') {
        if (localStorage.getItem('general_setting')) {
            const application_name = JSON.parse(localStorage.getItem('general_setting')).application_name
            return `${application_name} (${applicationStatus})`
        } else {
            return `${window.__RUNTIME_CONFIG__.REACT_APP_NAME} (${applicationStatus})`
        }
    } else {
        return window.__RUNTIME_CONFIG__.REACT_APP_NAME
    }
}

export default AppName